<section class="content-header">

    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1 class="m-0 text-dark">Update FSW Status</h1>
            </div>

        </div>
        <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
</section>
<section class="content">
    <!-- Default box -->
    <div class="container-fluid">

        <div class="card">

            <div class="card-body">

                <div class="container" *ngIf="isReadMode">
                    <div class=" row">
                        <div class="col-12">
                            <p style="float:right">

                                <input type="button" (click)="createRow()" value="Add FSW Status" class="btn btn-link">
                            </p>
                        </div>

                    </div>
                    <div class="row">

                        <div class="col-md-12">
                            <p style="float:right"><input type="button" class="btn btn-link" (click)="backOption()"
                                    class="btn btn-link" value="Back"></p>
                        </div>
                    </div>

                    <div class="row">
                        <table class="table table-striped table-hover table-bordered">
                            <thead>
                                <tr>
                                    <th style="font-weight:bold">S. No.</th>
                                    <th style="font-weight:bold">State Name</th>
                                    <th style="font-weight:bold">Allocated FSW</th>
                                    <th style="font-weight:bold">Running FSW</th>
                                    <th style="font-weight:bold">Action</th>
                                </tr>

                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="let fswStatus of fswStatusData | paginate : {itemsPerPage: 10, currentPage : p}; let i=index">
                                    <td>{{ itemsPerPage * (p - 1) + i + 1 }}</td>
                                    <td>{{fswStatus.stateName}}</td>
                                    <td>{{fswStatus.totalFswAlloted}}</td>
                                    <td>{{fswStatus.totalFswRunning}}</td>
                                    <td>
                                        <input type="button" (click)="updateRow(fswStatus)" value="Edit"
                                            class="btn btn-primary">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <pagination-controls (pageChange)="p = $event" class="float-right"></pagination-controls>
                    </div>

                </div>

                <div *ngIf="!isReadMode" style="margin-left: 150px;">
                    <div class="row">
                        <div class="col-mod-12">


                            <form [formGroup]="addFSWForm" (ngSubmit)="onsaveFsw()">
                                <div class="form-group">
                                    <!-- <label>
                                        State:<span style="color:red;">*</span>
                                        <select [(ngModel)]="selectedState" style="width:600px" formControlName="stateCode" class="form-control">
                                            <option [ngValue]="null" selected disabled>Select State</option>
                                            <option *ngFor="let state of StateRecord" [ngValue]="state.stateCode">
                                                {{state.stateName}}</option>
                                        </select>
                                        <div *ngIf="submitted && addFSWForm.controls.stateCode.errors" class="error">
                                            <div *ngIf="addFSWForm.controls.stateCode.errors.required"
                                                style="color:red">State is required</div>
                                        </div>
                                    </label> -->
                                    <label>
                                        State:
                                        <div>{{selectedState}}</div>
                                    </label>
                                    
                                </div>
                               <div class="form-group">
                                    <label style="font-weight:bold">
                                        Allocated FSW :<span style="color:red;">*</span>
                                        <input type="text" style="width:650px" formControlName="totalFswAlloted"
                                            class="form-control" [ngClass]="{ 'is-invalid': submitted && f.totalFswAlloted.errors }">
                                            <div *ngIf="submitted && f.totalFswAlloted.errors" class="invalid-feedback">
                                                <div *ngIf="f.totalFswAlloted.errors.required">No. of Trainees is required</div>
                                                <div *ngIf="f.totalFswAlloted.errors.pattern">Enter only Number</div>
                                            </div>
                                    </label>
                                </div>
                                <div class="form-group">
                                    <label style="font-weight:bold">
                                        Running FSW :<span style="color:red;">*</span>
                                        <input type="text" style="width:650px" formControlName="totalFswRunning"
                                            class="form-control" [ngClass]="{ 'is-invalid': submitted && f.totalFswRunning.errors }">
                                            <div *ngIf="submitted && f.totalFswRunning.errors" class="invalid-feedback">
                                                <div *ngIf="f.totalFswRunning.errors.required">No. of Trainees is required</div>
                                                <div *ngIf="f.totalFswRunning.errors.pattern">Enter only Number</div>
                                            </div>
                                            <input type="hidden" class="form-control" formControlName="id">
                                    </label>
                                </div>
                                <br />

                                <div class="form-group" style="text-align: center;"><input type="submit" value="Submit" class="btn btn-primary"
                                        [disabled]="!addFSWForm.valid">&nbsp;&nbsp;&nbsp;
                                    <input type="button" (click)="backOption()" value="Back" class="btn btn-primary"
                                        >
                                        
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
</ngx-spinner>